import React, { useContext } from 'react';

//context
import { WebEmbedContext } from '@/context/WebEmbed';

//enums
import { EmbedType, WidgetType } from  '@/interfaces/widgetPanel';

//modal functionality
import UseWebEmbedModal from './WebEmbedModal.hooks';

//components
import WidgetButton from  '@/components/elements/widgets/WidgetButton/WidgetButton';
import Dropdown from  '@/components/elements/global/Dropdown';
import TextAndSearchInput from  '@/components/elements/global/textInputs/TextAndSearchInput';
import WebEmbedPreview from  '@/components/elements/widgets/webEmbed/preview/WebEmbedPreview';
import CodeMirrorInput from  '@/components/elements/global/textInputs/CodeMirrorInput';

//styling
import '../../../css/widgetPanel/webEmbed.scss';



const WebEmbedModal = ({hideModal}: {hideModal:any}) => {
    const {embedType, setEmbedType, inputValue, setInputValue, embedId, setEmbedId, isDctEnabled} = useContext(WebEmbedContext);
    const {isLoading, setIsLoading, onCheckContentClick, inputPlaceholderText, disableUpload, setDisableUpload, showPreview, getDropdownIcon, getDropdownIconAlt, onUploadClick} = UseWebEmbedModal(embedType, inputValue, embedId);

    return (
        <div className="web-embed-widget-modal">
            <h1>Web Embed</h1>

            {/* panel with embedding type options */}
            {!embedType
            ?   <div className="select-embed-type-panel">
                    <WidgetButton onClick={() => setEmbedType(EmbedType.YOUTUBE)}       type={WidgetType.YOUTUBE} />
                    <WidgetButton onClick={() => setEmbedType(EmbedType.VIMEO)}         type={WidgetType.VIMEO} />
                    <WidgetButton onClick={() => setEmbedType(EmbedType.GIPHY)}         type={WidgetType.GIPHY} />
                    <WidgetButton onClick={() => setEmbedType(EmbedType.GOOGLE_MAPS)}   type={WidgetType.GOOGLE_MAPS} />
                    <WidgetButton onClick={() => setEmbedType(EmbedType.HTML)}          type={WidgetType.HTML} />
                </div>
            
            // panel with url input and preview of media
            :   <>
                    <div className="select-embed-type-dropdown">
                        <span>SELECT EMBED TYPE: </span>
                        
                        <Dropdown setValue={(value: EmbedType) => setEmbedType(value)} defaultValue={embedType} canDeselectValue={false} defaultIcon={[getDropdownIcon(embedType), getDropdownIconAlt(embedType)]}
                            options={[{icon: getDropdownIcon(EmbedType.YOUTUBE),    label: "YouTube",       value: EmbedType.YOUTUBE,       iconAlt: 'youtube play button'}, 
                                      {icon: getDropdownIcon(EmbedType.VIMEO),      label: "Vimeo",         value: EmbedType.VIMEO,         iconAlt: 'vimeo V'}, 
                                      {icon: getDropdownIcon(EmbedType.GIPHY),      label: "Giphy",         value: EmbedType.GIPHY,         iconAlt: 'giphy file'}, 
                                      {icon: getDropdownIcon(EmbedType.GOOGLE_MAPS),label: "Google Maps",   value: EmbedType.GOOGLE_MAPS,   iconAlt: 'map pin'}, 
                                      {icon: getDropdownIcon(EmbedType.HTML),       label: "HTML",          value: EmbedType.HTML,          iconAlt: 'code file'}]} 
                        />
                    </div>

                    
                    {embedType !== EmbedType.HTML
                    // input box with button and media preview
                    ?   <>
                        <TextAndSearchInput inputId={"embed-value-input"} inputValue={inputValue} setInputValue={(value: string) => setInputValue(value)} onButtonClick={onCheckContentClick} isLoading={isLoading} inputPlaceholderText={inputPlaceholderText} hasHiddenLabel/>
                        <WebEmbedPreview inputValue={inputValue} embedType={embedType} setDisableUpload={(value: boolean) => setDisableUpload(value)} showPreview={showPreview} setIsLoading={(value: boolean) => setIsLoading(value)} isLoading={isLoading} setEmbedId={(value: string) => setEmbedId(value)} />
                        </>
                    
                    // textbox for html input
                    :  <CodeMirrorInput setInputValue={(value: string) => setInputValue(value)} maxLength={10000} limitReachedMessage={'Content within HTML over 10,000 characters will not be translated.'} setDisableUpload={(value: boolean) => setDisableUpload(value)} isDctEnabled={isDctEnabled}/>
                    }
            
                    <div className='button-panel'>
                        <button className="cancel-button" onClick={hideModal}>Cancel</button>
                        <button className="insert-button" disabled={disableUpload} onClick={onUploadClick}>Insert</button>
                    </div>
                </>
            }
        </div>
    )
}
export default WebEmbedModal